import React, { useState, useRef, useEffect } from 'react';
import { useLang, LANGS, LANG_META } from '../lib/i18n';

/**
 * Language switcher with flag emojis.
 * Compact button showing current flag; dropdown lists all three.
 */
export default function LanguageSwitcher({ variant = 'header' }) {
  const { lang, setLang } = useLang();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const current = LANG_META[lang];

  return (
    <div className="relative inline-block" ref={ref} data-testid="language-switcher">
      <button
        onClick={() => setOpen((o) => !o)}
        aria-label="Change language"
        className={
          variant === 'header'
            ? 'inline-flex items-center gap-1.5 text-xs uppercase tracking-widest text-white/70 hover:text-[#c9a063] transition-colors px-2 py-1'
            : 'inline-flex items-center gap-1.5 text-xs text-white/70 hover:text-[#c9a063]'
        }
        data-testid="language-switcher-toggle"
      >
        <span className="text-base leading-none" aria-hidden>{current.flag}</span>
        <span>{current.short}</span>
        <svg width="8" height="8" viewBox="0 0 8 8" fill="none" aria-hidden><path d="M1 2.5L4 5.5L7 2.5" stroke="currentColor" strokeWidth="1.2" /></svg>
      </button>
      {open && (
        <div className="absolute right-0 mt-2 min-w-[140px] bg-[#0d0d0e] border border-white/10 shadow-2xl z-50" data-testid="language-switcher-menu">
          {LANGS.map((code) => {
            const meta = LANG_META[code];
            const active = code === lang;
            return (
              <button
                key={code}
                onClick={() => { setLang(code); setOpen(false); }}
                className={`w-full text-left px-4 py-2.5 text-xs uppercase tracking-widest flex items-center gap-3 hover:bg-[#c9a063]/10 transition-colors ${active ? 'text-[#c9a063]' : 'text-white/70'}`}
                data-testid={`language-option-${code}`}
              >
                <span className="text-base leading-none" aria-hidden>{meta.flag}</span>
                <span>{meta.label}</span>
                {active && <span className="ml-auto text-[9px] opacity-60">●</span>}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
